/* eslint-disable */
export default {
  Active: 'Active',
  Deleted: 'Deleted',
  Paused: 'UserPaused',
  Suspended: 'Suspended',
  InProgress: 'InProgress',
  EnumPaused: 124,
  EnumBudgetPaused: 126,
  EnumBudgetUserPaused: 127
};

